var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackageSixMonths(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-3{fill:#a2c037;}.cls-2{opacity:0.3;}.cls-4{mix-blend-mode:multiply;}.cls-5{fill:#6aa842;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tavola disegno 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -4.43,
    y: -10,
    width: 808.85,
    height: 820
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.21,446.59q12.81-47.76,39-95.51t67-98.42Q262,202,317.88,140.26L455.33-10H677.8L447.17,235.77q7,0,13.4.58t12.23.58q52.41,3.49,94.34,24.46t71.06,54.75a235.65,235.65,0,0,1,44.26,77.45,280.85,280.85,0,0,1,15.14,92.6q0,68.73-22.13,127.55t-62.9,102.5q-40.77,43.68-99,68.72T383.11,810q-74.55,0-127.54-23.88t-87.36-61.73q-34.36-37.86-50.09-84.45T102.4,549.09Q102.4,494.34,115.21,446.59Zm247.52-37.27A117,117,0,0,0,326,440.18a132.89,132.89,0,0,0-22.72,44.27,174.39,174.39,0,0,0-7.57,50.66q0,44.26,26.79,72.8t68.72,28.54q52.42,0,82.7-37.86t30.29-93.76q0-52.41-25.63-79.79t-66.39-27.37Q384.27,397.67,362.73,409.32Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M207.48,529.88l6.85-109.31q.39-5.71.95-12.95c.39-4.83.83-9.71,1.34-14.67s.95-9.71,1.33-14.28.83-8.5,1.33-11.81h-1.52q-1.9,5.34-4.76,12.95t-6.28,15.24q-3.43,7.62-6.48,14.47t-4.57,11.05L149.58,529.88H106.17L94.36,420.19q-.77-8.76-2.48-24t-2.47-29.33H87.88Q86,377.92,82.74,393.14t-6.28,26.28L47.89,529.88H-10L60.84,270.12h64.75l14.85,96q1.91,11.43,3.43,24.19t2.29,23.42h1.52q4.19-10.66,9.71-24.18t10.1-23.43l43.8-96h67.79l-8.76,259.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M395.62,328.4l-6.48,40.37h88l-8.38,54.46h-88l-7.61,48.37H468l-9.14,58.28H298.5l41.13-259.76H496.17l-9.52,58.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M624.71,322.68a23.55,23.55,0,0,0-15.8-6.09q-10.29,0-16.76,5.9t-6.48,16.57a21.81,21.81,0,0,0,7.24,16.38q7.23,6.85,19.8,12.95Q647,384.77,661.85,405t14.85,48.37q0,20.19-6.86,36A74.11,74.11,0,0,1,650.61,516a84.81,84.81,0,0,1-29.52,16.57,118.55,118.55,0,0,1-37.7,5.72,120.26,120.26,0,0,1-34.85-4.77,71.19,71.19,0,0,1-27.61-15.42q-11.82-10.67-19.24-27.42t-9.33-40.76h65.51q0,17.52,8.76,25.52a30,30,0,0,0,21,8q11.42,0,18.28-7.05t6.85-17.71q0-10.27-7.23-19t-25.9-17.52q-30.09-14.47-44-34.85T521.69,341a78,78,0,0,1,6.47-31.81A74.48,74.48,0,0,1,546.06,284a82.39,82.39,0,0,1,27.23-16.38,97.69,97.69,0,0,1,34.47-5.91q40,0,63.23,21.52t25.52,58.47h-64Q631.76,328.77,624.71,322.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M810,270.12,768.87,529.88H703.36l41.13-259.76Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageSixMonths);
export default __webpack_public_path__ + "static/media/packageSixMonths.8bf9e954c964bf666b1157baffe86a59.svg";
export { ForwardRef as ReactComponent };